var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"mb-0"},[(_vm.rowNumber)?_c('strong',[_vm._v("Row: "+_vm._s(_vm.rowNumber)+".")]):_vm._e(),_vm._v(" "+_vm._s(_vm.message)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }